import Script from "next/script";
import type { FunctionComponent } from "react";

export const OnePlusXScripts: FunctionComponent = () => (
  <>
    <Script
      dangerouslySetInnerHTML={{
        __html: `
              (function(window,ope){
                window[ope]=window[ope]||function(){
                  (window[ope].q=window[ope].q||[]).push(arguments);
                };
              }(window,"ope"));
              `,
      }}
      id="one-plus-x-before-script"
      strategy="worker"
    />
    <Script id="one-plus-x" src="https://cdn.opecloud.com/ope-scmp.js" strategy="worker" />
    <Script
      dangerouslySetInnerHTML={{
        __html: `
          ope("scmp", "init", "implied",{
            "taggerUrl": "https://tagger.ope.scmp.com/",
            "profileApiUrl": "https://profiles.ope.scmp.com/api/v1/scmp/profile",
            "visitProvider": "cmd"
          });
        `,
      }}
      id="one-plus-x-after-script"
      strategy="worker"
    />
  </>
);

OnePlusXScripts.displayName = "OnePlusXScripts";
